import { useRef, } from 'react';
import BaseFilesService, { BaseFilesServiceProps } from '../../utilsTsx/components/files/BaseFilesService';
import systematic from '../../config/systematic';

const FilesService = (props: any) => {
    const ref = useRef<any>(undefined);
    const extendProps: BaseFilesServiceProps = {
        defaultService: systematic.bmService
    }

    return (
        <>
            <BaseFilesService {...extendProps} ref={ref} />
        </>
    )
}

export default FilesService;